import React from "react"
import { CheckoutSummaryProductCard } from "@sixty-six-north/ui-system"
import { DiscountCodeInfo, LineItem } from "@commercetools/platform-sdk"
import { useTranslation } from "react-i18next"
import { usePreferredLanguage } from "../../i18n/StoreHooks"
import { useCartState } from "../../cart/CartServiceHook"
import { useOrderState } from "../../cart/OrderService"
import { SKU, variantData } from "../../product/VariantProxy"
import { useDiscount } from "../DiscountHooks"
import { getAllDiscountNamesForItem } from "../../utils/DiscountUtils"

export const CartSummaryLineItem: React.FC<{ item: LineItem }> = ({ item }) => {
  const { t } = useTranslation()
  const language = usePreferredLanguage()
  const cart = useCartState()
  const order = useOrderState()
  const cartDiscountCodes: DiscountCodeInfo[] =
    cart?.discountCodes || order?.discountCodes || []
  const { discountedPriceAndPriceBeforeDiscounted } = useDiscount()
  const itemPrice = discountedPriceAndPriceBeforeDiscounted(item)
  const discountNames = getAllDiscountNamesForItem({
    cartDiscountCodes,
    item,
    language
  })
  const { listingDescription, color, size, mainAsset } = variantData(
    item.variant,
    language
  )

  return (
    <CheckoutSummaryProductCard
      productName={item.name[language]}
      productDescription={listingDescription}
      productColor={color}
      productSize={size}
      productQuantity={item.quantity.toString()}
      productPrice={itemPrice.productPrice}
      discountedPrice={itemPrice.discountedPrice}
      productSku={item.variant.sku as SKU}
      discountNames={discountNames}
      productImageUrl={mainAsset.url}
      productImageTitle={mainAsset.label || ""}
      translations={{
        color: t("product:color"),
        size: t("checkout:size"),
        quantity: t("product:quantity"),
        sku: t("checkout:sku")
      }}
    />
  )
}
